export const METRO_REQUEST_MGL = 'MGL';
export const METRO_REQUEST_HQ = 'HQ';
export const METRO_REQUEST_STORE = 'Store';

export const METRO_REQUEST_ROUTE_TYPES = {
    [METRO_REQUEST_STORE]: 'store',
    [METRO_REQUEST_MGL]: 'mgl',
    [METRO_REQUEST_HQ]: 'hq',
};

export const METRO_REQUEST_ROUTES = [
    { id: METRO_REQUEST_MGL, name: METRO_REQUEST_ROUTE_TYPES[METRO_REQUEST_MGL] },
    { id: METRO_REQUEST_STORE, name: METRO_REQUEST_ROUTE_TYPES[METRO_REQUEST_STORE] },
    { id: METRO_REQUEST_HQ, name: METRO_REQUEST_ROUTE_TYPES[METRO_REQUEST_HQ] },
];

export const METRO_REQUEST_ROUTES_FILTERS = {
    [METRO_REQUEST_STORE]: 1,
    [METRO_REQUEST_MGL]: 2,
    [METRO_REQUEST_HQ]: 3,
};

export const METRO_REQUEST_CURRENT = 1;
export const METRO_REQUEST_NEW = 2;

export const METRO_REQUEST_TYPES = [
    { id: METRO_REQUEST_CURRENT, name: 'current' },
    { id: METRO_REQUEST_NEW, name: 'new' },
];

export const METRO_REQUEST_TYPES_CURRENT = [
    { id: METRO_REQUEST_CURRENT, name: 'current' },
];

export const METRO_REQUEST_DRAFT = 2;
export const METRO_REQUEST_INWORK = 3;
export const METRO_REQUEST_APPROVED = 4;
export const METRO_REQUEST_REJECTED = 8;
export const METRO_REQUEST_CLOSED = 6;

export const METRO_ROLE_BACKOFFICE = 8;
export const METRO_ROLE_ACO = 5;
export const METRO_ROLE_CB = 14;
export const METRO_ROLE_CB_RATE = 4;

export const METRO_REQUEST_APPROVALS = {
    [METRO_ROLE_ACO]: 'aco',
    [METRO_ROLE_BACKOFFICE]: 'back',
    [METRO_ROLE_CB]: 'cnb',
    [METRO_ROLE_CB_RATE]: 'cnbrate',
};

export const POSITION_PREFIX = 2;

export const OBJ_TYPE = 'MetroRequest';
